import Helper from "./Helper";

class LottieAccordion {
  constructor() {
    this.accordions = document.querySelectorAll('.lc-lottie-accordion');
    this.activeClass = 'active';
    this.buttonTransition = 'opacity 220ms ease, transform 220ms ease';

    this.container = document.querySelector('.iz-content__content') || document;

    if (!this.container.__lottieAccordionDelegatedBound) {
      this.handleDelegatedClick = this.onDelegatedClick.bind(this);
      this.container.addEventListener('click', this.handleDelegatedClick);
      this.container.__lottieAccordionDelegatedBound = true;
    }

    this.init();
  }

  init() {
    this.accordions.forEach((accordion) => {
      const content = accordion.querySelector('.lc-lottie-accordion__content');
      const buttonContainer = accordion.querySelector('.lc-button-lottie__accordion');
      if (!content) return;

      this.prepareAccordionLotties(content);

      content.style.height = '0px';
      content.style.overflow = 'hidden';
      accordion.classList.remove(this.activeClass);
      content.classList.remove(this.activeClass);

      this.setupButtons(buttonContainer);
      this.setButtonState(buttonContainer, false);
    });
  }

  prepareAccordionLotties(content) {
    const players = content.querySelectorAll('lottie-player');

    players.forEach((player) => {
      if (!player) return;

      player.dataset.lottieAccordion = 'true';

      try {
        if (typeof player.stop === 'function') {
          player.stop();
        } else if (typeof player.pause === 'function') {
          player.pause();
        }
      } catch (error) {
        // Ignore if the player is not upgraded yet.
      }
    });
  }

  onDelegatedClick(event) {
    const buttonContainer = event.target && (event.target.closest ? event.target.closest('.lc-button-lottie__accordion') : null);
    if (!buttonContainer || !this.container.contains(buttonContainer)) return;

    const accordion = buttonContainer.closest('.lc-lottie-accordion');
    if (!accordion) return;

    const content = accordion.querySelector('.lc-lottie-accordion__content');
    if (!content) return;

    const link = event.target.closest ? event.target.closest('a') : null;
    if (link) event.preventDefault();

    if (content.classList.contains(this.activeClass)) {
      Helper.slideClose(content);
      content.classList.remove(this.activeClass);
      accordion.classList.remove(this.activeClass);
      this.setButtonState(buttonContainer, false);
      return;
    }

    content.classList.add(this.activeClass);
    accordion.classList.add(this.activeClass);
    Helper.slideOpen(content, true);
    this.setButtonState(buttonContainer, true);
    this.playLotties(content);
  }

  playLotties(content) {
    if (!content) return;

    const players = content.querySelectorAll('lottie-player');
    players.forEach((player) => {
      if (!player) return;

      const start = () => {
        try {
          if (typeof player.stop === 'function') {
            player.stop();
          } else if (typeof player.seek === 'function') {
            player.seek(0);
          }

          if (typeof player.play === 'function') {
            player.play();
          }
        } catch (error) {
        }
      };

      if (typeof player.play === 'function') {
        start();
        return;
      }

      try {
        player.addEventListener('ready', start, { once: true });
      } catch (error) {
      }
    });
  }

  setupButtons(buttonContainer) {
    if (!buttonContainer) return;

    const moreButton = buttonContainer.querySelector('.lc-button__more');
    const lessButton = buttonContainer.querySelector('.lc-button__less');
    if (!moreButton || !lessButton) return;

    buttonContainer.style.position = 'relative';

    [moreButton, lessButton].forEach((button) => {
      button.style.transition = this.buttonTransition;
      button.style.willChange = 'opacity, transform';
    });

    lessButton.style.position = 'absolute';
    lessButton.style.left = '0';
    lessButton.style.top = '0';
  }

  setButtonState(buttonContainer, isOpen) {
    if (!buttonContainer) return;

    const moreButton = buttonContainer.querySelector('.lc-button__more');
    const lessButton = buttonContainer.querySelector('.lc-button__less');
    if (!moreButton || !lessButton) return;

    if (isOpen) {
      moreButton.style.opacity = '0';
      moreButton.style.transform = 'translateY(-6px)';
      moreButton.style.pointerEvents = 'none';

      lessButton.style.opacity = '1';
      lessButton.style.transform = 'translateY(0)';
      lessButton.style.pointerEvents = 'auto';
      return;
    }

    moreButton.style.opacity = '1';
    moreButton.style.transform = 'translateY(0)';
    moreButton.style.pointerEvents = 'auto';

    lessButton.style.opacity = '0';
    lessButton.style.transform = 'translateY(6px)';
    lessButton.style.pointerEvents = 'none';
  }
}

export default LottieAccordion;
